import React, { useState, useEffect } from "react";
import classes from "../AuthLayout/style.module.scss";
import AuthShell from "../AuthLayout/AuthShell";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  setMainUserLogin,
  setOtpExpired,
  setResendOtp,
} from "../../redux/ducks/auth";
import { HOME_URL } from "../../utils/constants";

const ConfirmOtp = (props) => {
  const [otp, setOtp] = useState("");
  const { isAuthLoading, isAuthenticated, otpExpired } = useSelector(
    (state) => state.auth
  );
  const [counter, setCounter] = useState(600);
  const [showResendButton, setShowResendButton] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleInputFied = (e) => {
    e.preventDefault();
    setOtp(e.target.value);
  };

  const userLogin = async (e) => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem("tempToken");
      if (token && otp) {
        await dispatch(
          setMainUserLogin({
            code: otp,
            token: token,
          })
        );
      }
      if (otpExpired) {
        setOtp("");
        setCounter(120);
      }
    } catch (error) {
    }
  };

  const onClickResendButton = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("tempToken");
    const objBody = {
      token: token,
    };
    const loginMainUser = await dispatch(setResendOtp(objBody));
    if (loginMainUser.payload?.token) {
      setOtp("");
      setCounter(120);
    }
    setShowResendButton(false);
    dispatch(setOtpExpired(false));
  };

  useEffect(() => {
    if (isAuthenticated) navigate(HOME_URL);
  }, [isAuthenticated]);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
    }

    if (counter === 0) {
      toast(
        "Verification code expired !!, please click on resend code to generate new verification code",
        { type: "info" }
      );
      setShowResendButton(true);
    }

    return () => clearTimeout(timer);
  }, [counter]);

  const minutes = Math.floor(counter / 60);
  const seconds = counter % 60 < 10 ? `0${counter % 60}` : counter % 60;
  const isExpiredView = otpExpired || showResendButton;

  return (
    <AuthShell
      heading={
        <>
          One more step
          <br />
          to keep your
          <br />
          account secure.
        </>
      }
    >
      {isExpiredView ? (
        <>
          <div className={classes["status-icon-hold"]}>
            <svg
              className={classes["status-icon"]}
              width="34"
              height="34"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h1 className={classes["heading"]}>Code expired</h1>
          <p className={classes["sub"]}>
            That verification code has expired. Request a new one to
            finish logging in.
          </p>
          <div className={classes["form"]}>
            <button
              className={classes["submit-btn"]}
              onClick={onClickResendButton}
            >
              Resend code
            </button>
          </div>
        </>
      ) : (
        <>
          <h1 className={classes["heading"]}>Enter verification code</h1>
          <p className={classes["sub"]}>
            Enter the verification code we sent you to continue.
          </p>

          <form className={classes["form"]}>
            <div className={classes["field"]}>
              <label htmlFor="userOtp" className={classes["field-label"]}>
                Verification code
              </label>
              <input
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                className={
                  classes["field-input"] + " " + classes["otp-input"]
                }
                id="userOtp"
                name="otp"
                aria-describedby="otpHelp"
                placeholder="Enter your code here"
                onChange={(e) => handleInputFied(e)}
                value={otp}
                autoFocus
              />
            </div>

            <button
              type="submit"
              className={classes["submit-btn"]}
              onClick={userLogin}
              disabled={otp === "" || isAuthLoading}
            >
              {isAuthLoading ? (
                <span className={classes["btn-spinner"]} />
              ) : (
                "Submit"
              )}
            </button>

            {counter > 0 && (
              <p className={classes["otp-timer"]} id="otpHelp">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="9" />
                  <polyline points="12 7 12 12 15.5 14" />
                </svg>
                Code expires in {minutes}:{seconds} minutes
              </p>
            )}
          </form>
        </>
      )}
    </AuthShell>
  );
};

export default ConfirmOtp;
